import { Camera, CameraResultType } from '@capacitor/camera'
import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'
import { IonContent, IonPage, useIonRouter } from '@ionic/react'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { rentalFrontend } from '../apiConfig'
import DummyHeader from '../components/DummyHeader'
import sendToIframe from '../sendToIframe'
import { selectSession } from '../store'

const iframeTitle = 'rental'

export default function Rental() {
  const { authToken, locale } = useSelector(selectSession)
  const { routeInfo } = useIonRouter()
  const iframeSrc = useMemo(() => (routeInfo.pathname === '/tabs/rental' ? `${rentalFrontend}?token=${authToken}&locale=${locale}` : ''), [authToken, routeInfo])

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      try {
        const { action, url } = JSON.parse(event.data)

        if (action === 'CapturePhoto') {
          Camera.getPhoto({
            quality: 30,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
          })
            .then(({ dataUrl }) => {
              sendToIframe({ type: 'PhotoCaptured', dataUrl }, iframeTitle)
            })
            .catch((e) => {
              console.log(e)
            })
        }
        if (action === 'OpenUrl') {
          window.open(url, '_blank')
        }
      } catch {
        // ignore
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [])

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', () => sendToIframe({ type: 'keyboardWillShow' }, iframeTitle))
      Keyboard.addListener('keyboardDidHide', () => sendToIframe({ type: 'keyboardDidHide' }, iframeTitle))
    }

    return () => {
      if (Capacitor.isNativePlatform()) {
        Keyboard.removeAllListeners()
      }
    }
  }, [])

  return (
    <IonPage>
      <DummyHeader />
      <IonContent>
        <iframe title={iframeTitle} src={iframeSrc} style={{ width: '100%', height: '100%' }} />
      </IonContent>
    </IonPage>
  )
}
